module.exports = __webpack_public_path__ + "img/derivDownOff.6ad0435f.svg";